import PropTypes from 'prop-types';
import {urlFor} from '../lib/sanity.js';

export default function ImageMediaItem({item}) {
    return (
        <div
            className="aspect-video bg-zinc-800 rounded-xl border border-zinc-700/50 flex items-center justify-center hover:border-amber-500/30 transition-colors overflow-hidden">
            <img
                src={urlFor(item.image).width(1200).url()}
                alt={item.title || 'Media item'}
                className="w-full h-full aspect-video object-cover"
            />
        </div>
    );
}

ImageMediaItem.propTypes = {
    item: PropTypes.shape({
        image: PropTypes.object.isRequired,
        title: PropTypes.string,
    }).isRequired,
};
